<template>
  <v-container
    grid-list-xl
    fluid
  >
    <div>
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
        >
          <v-alert
            :value="group.errors.length"
            type="error"
            icon="new_releases"
            dismissible
          >
            <div v-html="group.errorsText()"/>
          </v-alert>
        </v-flex>
        <v-flex
          xs12
          md12
        >
          <CustomerGroup :group="group" />
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import CustomerGroup from '../components/GroupSingle'

export default {
  name: 'CustomerGroupNewPage',

  components: {
    CustomerGroup
  },

  async beforeRouteLeave (to, from, next) {
    if (this.group && this.group.isDirty()) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })
      if (answer) {
        this.group.reset()
      }
      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      title: 'New Group',
      actions: [
        {
          color: 'grey',
          text: 'Cancel',
          event: 'cancel'
        },
        {
          text: 'Create',
          event: 'create'
        }
      ]
    }
  },

  data () {
    return {
      group: this.$http.make('customer:group')
    }
  },

  computed: {
    createActionStates () {
      return {
        disabled: !this.group || this.group.inProgress || !this.group.isDirty() || this.group.errors.length,
        loading: !this.group || this.group.inProgress
      }
    },

    cancelActionStates () {
      return {
        disabled: !this.group || this.group.inProgress
      }
    }
  },

  methods: {
    onActionCancel () {
      this.$router.replace({ name: 'groups' })
    },

    async onActionCreate () {
      if (this.group.customers) {
        this.group.customer_ids = this.group.customers.map(item => item.id)
      }

      await this.group.save().then(() => {
        this.$router.push({
          name: 'single-customer-group',
          params: { id: this.group.id }
        })
      }).catch(e => {
        this.$vuetify.goTo(0)
        this.$toast.error(this.$t(e.message))
      })
    }
  }
}
</script>
